<script setup>
import { useAttrs, useListeners } from 'vue';
import { tableRecipe } from './table.recipe';
import { useTableContext } from './useTable';

/**
 * @typedef {object} TableCellProps
 * @property {boolean} [isSelected=false] - Whether the table cell is in a selected state.
 */

/**
 * @type {TableCellProps}
 */
const props = defineProps({
  isSelected: {
    type: Boolean,
    default: false,
  },
});

const { cell } = tableRecipe();

const { rootProps } = useTableContext();

const attrs = useAttrs();
const listeners = useListeners();
</script>

<template>
  <td
    data-component="CsTableCell"
    :class="cell(rootProps)"
    :data-selected="props.isSelected || undefined"
    v-bind="attrs"
    v-on="listeners"
  >
    <slot />
  </td>
</template>
